"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReducer = exports.setCredentials = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    clientId: "",
    userId: "",
    accessToken: "",
    refreshToken: "",
    name: "",
    email: "",
    role: "",
    permissions: [],
    pwdResetRequired: false,
};
var authSlice = (0, toolkit_1.createSlice)({
    name: "authSlice",
    initialState: initialState,
    reducers: {
        setCredentials: function (state, action) {
            var _a = action.payload, clientId = _a.clientId, userId = _a.userId, accessToken = _a.accessToken, refreshToken = _a.refreshToken, name = _a.name, email = _a.email, role = _a.role, permissions = _a.permissions, pwdResetRequired = _a.pwdResetRequired;
            state.clientId = clientId;
            state.userId = userId;
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
            state.name = name;
            state.email = email;
            state.role = role;
            state.permissions = permissions;
            state.pwdResetRequired = pwdResetRequired;
        },
    },
});
exports.setCredentials = authSlice.actions.setCredentials;
exports.authReducer = authSlice.reducer;
